import { render, staticRenderFns } from "./myCollectDetail.vue?vue&type=template&id=03e3a1de&scoped=true&"
import script from "./myCollectDetail.vue?vue&type=script&lang=js&"
export * from "./myCollectDetail.vue?vue&type=script&lang=js&"
import style0 from "./myCollectDetail.vue?vue&type=style&index=0&id=03e3a1de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e3a1de",
  null
  
)

export default component.exports